import { InputLeftElement, Spinner } from '@chakra-ui/react';
import { FiSearch } from 'react-icons/fi';
import { MdNumbers } from 'react-icons/md';

export const SearchIcon = ({ isLoading }: { isLoading: boolean }) => {
  return (
    <InputLeftElement
      pointerEvents="none"
      color="black"
      fontSize="2xl"
      h="100%"
      w="56px"
      display="flex"
      alignItems="center"
      justifyContent="center"
      children={
        isLoading ? <Spinner size="sm" /> : <FiSearch color="green.500" />
      }
    />
  );
};

export const NumberIcon = ({ isLoading }: { isLoading: boolean }) => {
  return (
    <InputLeftElement
      pointerEvents="none"
      color="black"
      fontSize="2xl"
      h="100%"
      w="56px"
      display="flex"
      alignItems="center"
      justifyContent="center"
      children={
        isLoading ? <Spinner size="sm" /> : <MdNumbers color="green.500" />
      }
    />
  );
};
